import { render, staticRenderFns } from "./MyEcosystems.vue?vue&type=template&id=8a91d448&scoped=true&"
import script from "./MyEcosystems.vue?vue&type=script&lang=js&"
export * from "./MyEcosystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a91d448",
  null
  
)

export default component.exports